import { memo, useEffect, createContext,} from 'react';
import useMoveGroup from '../../../features/CamMovingCenter/hook/useMoveGroup';
import useCamMoveCenter from '../../../features/CamMovingCenter/hook/useCamMoveCenter';
import '../../../styles/uiBtn.scss';
import SceneEntrace from '../SceneEntrace/SceneEntrace';
import CanvasSetting from '../CanvasSetting/CanvasSetting';


export const MainContext: any = createContext(null);

const CanvasContainer = ({
    hallwayPositionX,
    setHallwayToLoby,
}: any) => {
    const camMoveCenter = useCamMoveCenter();

    const { lobyToHallway, hallwayToLoby } = useMoveGroup(camMoveCenter.center);

    useEffect(() => {
        setHallwayToLoby(() => () => {
            hallwayToLoby(); //長廊去大廳
        });

    });

    return (
        <MainContext.Provider value={{ ...camMoveCenter }}>
            <CanvasSetting />
            <SceneEntrace
                lobyToHallway={lobyToHallway}
                hallwayPositionX={hallwayPositionX}
            />
        </MainContext.Provider>
    );
};

export default memo(CanvasContainer);
